import { useState } from 'react';
import { encodeQueryData, staleTimeMins } from './utils';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './useAPIRequest';

export const useFetcher = props => {
	const {
		url,
		paginate,
		keepData,
		queryKey,
		staleTime,
		hasFilters,
		initialFilter,
		pageLimit,
	} = props;

	const [limit, setLimit] = useState(pageLimit ?? 50);
	const [filters, setFilters] = useState({});
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	const query = encodeQueryData({
		...(searchQuery && { search: searchQuery.trim().toLowerCase() }),
		...(paginate && { limit: limit, offset: currentPage + 1 }),
		...(hasFilters && filters),
		...(initialFilter && initialFilter),
	});

	const response = useQuery({
		queryKey: [...queryKey, query],
		queryFn: () => {
			return apiRequest({
				url: query ? `${url}?${query}` : url,
				method: 'get',
			});
		},
		keepPreviousData: keepData ? keepData : true,
		staleTime: staleTimeMins(staleTime ? staleTime : 60),
	});

	return {
		currentPage,
		setSearchQuery,
		setCurrentPage,
		filters,
		setFilters,
		limit,
		setLimit,
		onLimitChange,
		...response,
	};
};

export default useFetcher;
